const userLabsFeatures = {
    sideKick: "Sidekick",
    quickAddProduct: "QuickAddProduct",
    managerDeviceLicenseOverride: "ManagerDeviceLicenseOverride",
    ageVerification: "AgeVerification",
    orderAllocation: "OrderAllocation"
};

export default userLabsFeatures;